import { takeEvery, all, fork, put } from "redux-saga/effects";
import {
  GET_WORKING_HOURS,
  SUBMIT_CLOSURES_FORM,
  ADMIN_SETTINGS_SCHEDULE_SUBMIT,
  DELETE_CLOSURES,
  BUSINESS_PROFILE_SAVE,
  DELETE_GALLERY_IMAGE_REQUEST,
} from "../constants/ActionTypes";
import admin from "../services/admin";
import * as actions from "../actions";
import _ from "lodash";
import moment from "moment";
import { formatPhone } from '../util/normalizePhone';

function* getWorkingHours() {
  try {
    admin.defaults.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
    const businesslocations = localStorage.getItem("business_location");
    const user = JSON.parse(localStorage.getItem("user-data"));
    const response = yield admin.get(`/businesslocations/${businesslocations}`);
    console.log("TCL: function*getWorkingHours -> response", response)

    const response1 = yield admin.get(`/users/${user._id}`);
    console.log("TCL: function*getWorkingHours -> response1", response1)
    const { data } = response;
    const { operations } = data;

    const myOperations = {};
    Object.keys(operations).forEach(item => {
      myOperations[item] = {
        from: moment(`${moment().format("YYYY-MM-DD")} ${operations[item].from}`),
        to: moment(`${moment().format("YYYY-MM-DD")} ${operations[item].to}`),
      };
    });
    data.operations = myOperations;
    const { data: data1 } = response1;
    data.firstname = data1.firstname;
    data.lastname = data1.lastname;
    data.username = data1.username;
    data.userId = data1._id;
    data.email = data1.email;
    const myOject = {
      ...data,
      firstname: data1.firstname,
      lastname: data1.lastname,
      title: data1.title,
      userId: data1._id,
      email: data1.email,
    };
    console.log("TCL: function*getWorkingHours -> myOject", myOject)

    myOject.phonenumber = formatPhone(myOject.phonenumber);
    yield put(actions.setWorkingHours(myOject));
  } catch (error) {
    yield put(actions.failResponseMessage(error.response.data.message));
  }
}

function* scheduleSubmit({ payload }) {
  try {
    const businesslocations = localStorage.getItem("business_location");
    const response = yield admin.put(`/businesslocations/${businesslocations}`, {
      operations: payload,
    });
    console.log("TCL: function*scheduleSubmit -> response", response)


    if (response.status == 200) {
    //   let user = JSON.parse(localStorage.getItem("user-data"));
    //   // console.log("TCL: function*scheduleSubmit -> user.business.business_locations[0].operations", user.business.business_locations[0].operations)
    //   let business_locations = business_locations[0];
    //   business_locations.operations = response.data.operations;
    //   yield user.business.business_locations.pop();
    //   yield user.business.business_locations.push(business_locations);
    //   console.log("TCL: function*scheduleSubmit -> user", user)
    //   // console.log("TCL: function*scheduleSubmit -> user.business.business_locations[0].operations1", user.business.business_locations[0].operations)
    //   console.log("TCL: function*scheduleSubmit -> response.data.operations", response.data.operations)
    //   yield localStorage.setItem('user-data', JSON.stringify(user));
      // let user1 = JSON.parse(localStorage.getItem("user-data"));
      // console.log("TCL: function*scheduleSubmit -> user1", user1.business.business_locations[0].operations)
      // console.log("TCL: function*scheduleSubmit -> user.business.business_locations[0].operations", user1.business.business_locations[0].operations)
      
      yield put(actions.getWorkingHours());
      
    }
    yield put(actions.adminSettingsScheduleSubmitResponse(response.data));

  } catch (error) {
    yield put(actions.failResponseMessage(error.response.data.message));
  }
}

function* submitClosuresForm({ payload }) {
  try {
    admin.defaults.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
    const { addClosureState, editClosureState } = payload;
    if (addClosureState) {
      const response = yield admin.post("/businessclosures", payload);
      const { from, to, full_day_closed, _id, reason_for_closure } = response.data;
      const { location } = payload;
      const isNew = true;
      yield put(
        actions.closuresUpdate({
          from,
          to,
          full_day_closed,
          location,
          _id,
          isNew,
          reason_for_closure,
        })
      );
    } else if (editClosureState) {
      const { editId } = payload;
      const response = yield admin.put(`/businessclosures/${editId}`, payload);
      const { from, to, full_day_closed, _id, reason_for_closure } = response.data;
      const { location } = payload;
      const isNew = true;
      yield put(
        actions.editClosureResponse({
          from,
          to,
          full_day_closed,
          location,
          _id,
          isNew,
          reason_for_closure,
        })
      );
    }
  } catch (error) {
    yield put(actions.failResponseMessage(error.response.data.message));
  }
}

function* deleteClosures({ payload }) {
  try {
    const { selection } = payload;
    const deletePromises = selection.map(id => admin.delete(`/businessclosures/${id}`));

    const response = yield Promise.all(deletePromises);
    yield put(actions.deleteClosuresResponse({ selection }));
  } catch (error) {
    yield put(actions.failResponseMessage(error.response.data.message));
  }
}
function* deleteGalleryImages({ payload }) {
  const { id, from } = payload
  console.log("ID IN SAGA", payload);

  try {
    const response = yield admin.delete(`/upload/files/${id}`);
    console.log("response in saga", response);

    if (response.status == 200) {
      console.log("yes");
      if (from == "admin") {
        yield put(actions.getWorkingHours());
      } else if (from == "adminProfile") {
        yield put(actions.getWorkingHours());
        let user = JSON.parse(localStorage.getItem("user-data"));
        user.business.logo = null;
        localStorage.setItem('user-data', JSON.stringify(user));
        yield put(actions.toggleHeader(user))
      } else if (from == "superAdmin") {
        yield put(actions.requestBusinessDetail(localStorage.getItem("bussinessProfileId")));
      } else if (from == "customer") {
        yield put(actions.removeCustomerImageFile());
        yield put(actions.customerAdminFetchContacts());

      } else if (from == "employee") {
        let user = JSON.parse(localStorage.getItem("user-data"));
        yield put(actions.removeEmployeeImage());
        yield put(actions.fetchContacts(user.business._id));

      } else if (from == "userProfile") {
        let user = JSON.parse(localStorage.getItem("user-data"));
        user.customer_details.photo = null;
        localStorage.setItem('user-data', JSON.stringify(user));
        yield put(actions.removeCustomerImageFileProfile())
        // yield put(actions.fillCustomerProfileDetails())
      }
    }
  } catch (error) {
    console.log("errrr", error);

  }
};
function* businessProfileSave({ payload }) {
  try {
    const {
      email,
      businessname: name,
      phonenumber,
      description,
      website,
      address,
      _id,
      imageFile,
      firstname,
      lastname,
      title,
      userId,
      newPassword,
      confirmPassword,
      gallaryFile
    } = payload;
    if (gallaryFile)
      console.log("ADMINCAROUSEL", gallaryFile.length);


    const businesslocations = localStorage.getItem("business_location");
    let user = JSON.parse(localStorage.getItem("user-data"));

    const email1 = email === user.email ? null : email;
    const password = newPassword.length === 0 ? null : newPassword;

    const response = yield admin.put(`/businesslocations/${businesslocations}`, {
      address,
      phonenumber,
    });

    const response2 = yield admin.put(`/businesses/${_id}`, {
      name,
      description,
      website,
    });
    let imageResponse = null;
    let imageResponseGallery = null;
    let imageData = null;

    if (imageFile._id != payload.imageid) {
      console.log("TCL: imageFileTCL", imageFile)
      console.log('payload.imageid', payload.imageid)
      if (payload.imageid != "") {
        console.log('payload.imageid 1', payload.imageid)
        yield admin.delete(`/upload/files/${payload.imageid}`);
      }

      const file = new FormData();
      file.append("files", imageFile);
      file.append("refId", _id);
      file.append("ref", "business");
      file.append("field", "logo");

      imageResponse = yield admin.post("/upload?files", file, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    }
    console.log("imageResponseinSaga", imageResponse);


    if (gallaryFile) {
      console.log("gall", gallaryFile);
      console.log("gall", gallaryFile.length);
      const file = new FormData();
      for (let i = 0; i < gallaryFile.length; i++) {
        file.append("files", gallaryFile[i]);
      }
      file.append("refId", _id);
      file.append("ref", "business");
      file.append("field", "photos");
      imageResponseGallery = yield admin.post("/upload?files", file, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // }
    }
    yield put(actions.businessGallaryImageFileSucess());
    const myObject = {
      firstname,
      lastname,
      title,
    };

    if (email1) {
      myObject.email = email1;
    }
    if (password) {
      myObject.password = password;
    }

    const response3 = yield admin.put(`/users/${userId}`, myObject);
    user = { ...user, ...myObject };
    if (password) {
      delete user.password;
    }
    console.log('imageResponse', imageResponse != null)
    imageData = imageResponse == null ? imageFile : imageResponse.data === true ? imageFile : imageResponse.data[0];
    console.log("TCL: imageData", imageData)
    // console.log("TCL: imageResponse.data[0]", imageResponse.data[0])
    console.log("TCL: imageFile", imageFile)

    let { business } = user;
    const { business_locations } = business;
    business_locations[0].phonenumber = phonenumber;
    business_locations[0].address = address;
    business = {
      ...business,
      name,
      description,
      website,
      logo: imageData,
      business_locations,
    };
    user = { ...user, business };

    localStorage.setItem("user-data", JSON.stringify(user));

    yield put(actions.businessProfileSaveResponse(imageData));

    yield put(actions.toggleHeader(user));
  } catch (error) {
    console.log('error', error)
    yield put(actions.failResponseMessage(error.response.data.message));
  }
}

export function* requestWorkingHours() {
  yield takeEvery(GET_WORKING_HOURS, getWorkingHours);
}

export function* requestClosuresForm() {
  yield takeEvery(SUBMIT_CLOSURES_FORM, submitClosuresForm);
}

export function* requestScheduleSubmit() {
  yield takeEvery(ADMIN_SETTINGS_SCHEDULE_SUBMIT, scheduleSubmit);
}
export default function* rootSaga() {
  yield all([
    fork(requestWorkingHours),
    fork(requestClosuresForm),
    fork(requestScheduleSubmit),
    takeEvery(DELETE_CLOSURES, deleteClosures),
    takeEvery(BUSINESS_PROFILE_SAVE, businessProfileSave),
    takeEvery(DELETE_GALLERY_IMAGE_REQUEST, deleteGalleryImages)
  ]);
}



// WEBPACK FOOTER //
// ./sagas/AdminSettings.js